@use '../../../styles/variables' as *;
@use '../../../styles/mixins' as *;

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.92);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  animation: fade-in 0.2s ease-out;
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: $space-lg;
  max-width: 700px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  padding: $space-lg;

  @include scrollbar;
}

.header {
  text-align: center;

  h2 {
    color: $color-gold;
    font-size: $font-2xl;
    margin-bottom: 6px;
  }
}

.score {
  color: $color-text-muted;
  font-size: $font-md;
}

.empty {
  text-align: center;
  padding: 40px $space-lg;
  color: $color-text-dimmer;

  p {
    font-size: $font-lg;
    margin-bottom: $space-sm;
  }
}

.emptyHint {
  font-size: $font-sm;
  color: $color-text-faint;
  font-style: italic;
}

.closeBtn {
  @include gray-button;
  padding: 12px 30px;
  font-size: $font-md;
  margin-top: 10px;
}

.inventory {
  height: 450px;
}

.menuTabBtn {
  @include tab-button;
}
